<div class="main-container">
  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <rk-library-bac-group
      *ngFor="let group of bacsGroups$ | async"
      [groupBac]="group"
      [radioId]="currentRadioId$ | async"
      class="bacs-container"
    ></rk-library-bac-group>

    <ng-container *ngIf="!(isLoadingPlaylist$ | async); else loadingPlaylist">
      <rk-playlist-list
        *ngIf="playlists$ | async as playlist; else loadingPlaylist"
        [allPlaylists]="playlist"
        [radioId]="currentRadioId$ | async"
        class="playlist-container"
      ></rk-playlist-list>
    </ng-container>
  </ng-container>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #loading>
  <div class="loader-general hidden md:block">
    <rk-loader [isLoading]="true" [size]="60"></rk-loader>
  </div>
</ng-template>

<ng-template #loadingPlaylist>
  <div class="loader-playlist">
    <rk-loader [isLoading]="true" [size]="60"></rk-loader>
  </div>
</ng-template>
